export default "__VITE_ASSET__DBWaLxre__"